<template>
  <Drawer
    :id="drawerId"
    :title="title"
  >
    <template v-slot:customBack>
      <v-btn
        v-if="edit_design_group"
        icon
        color="black"
        @click="edit_design_group = null"
      >
        <v-icon>{{ backIcon }}</v-icon>
      </v-btn>
    </template>
    <v-sheet class="mt-5 px-4">
      <v-form
        ref="form"
        v-model="valid"
      >
        <v-row
          v-if="edit_design_group"
          dense
        >
          <v-col cols="12">
            This group is found in <span class="font-weight-bold">{{ industry.name }}</span>
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="edit_design_group.name"
              outlined
              :rules="[$rules.required]"
              hide-details="auto"
              label="Name"
            />
          </v-col>
        </v-row>
        <v-radio-group
          v-else
          v-model="project.designGroupId"
          mandatory
        >
          <v-row dense>
            <v-col cols="12">
              All design groups found in <span class="font-weight-bold">{{ industry.name }}</span>
            </v-col>
            <v-col
              v-for="design_group in design_groups"
              :key="design_group.id"
              cols="12"
            >
              <v-sheet
                class="rounded bordered border-light pa-4"
              >
                <v-row>
                  <v-col cols="auto">
                    <v-radio
                      :value="design_group.id"
                      :label="design_group.name"
                    />
                  </v-col>
                  <v-spacer />
                  <v-col cols="auto">
                    <v-btn
                      v-if="!design_group.isAdminGroup"
                      icon
                      small
                      @click="editDesignGroup(design_group)"
                    >
                      <v-icon small>
                        {{ editIcon }}
                      </v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-sheet>
            </v-col>
            <v-col cols="12">
              <v-btn
                outlined
                block
                x-large
                class="border-light"
                @click="editDesignGroup"
              >
                <v-icon
                  small
                  class="mr-2"
                >
                  {{ alertIcon }}
                </v-icon>
                Create a new group
              </v-btn>
            </v-col>
          </v-row>
        </v-radio-group>
        <v-row dense>
          <v-col
            cols="12"
          >
            <div
              class="light rounded-lg pa-4"
            >
              Design groups help you organize your published templates within your catalog, making it easier for others to find what they need. The names you assign to these groups will be visible to anyone with access to your catalog.
            </div>
          </v-col>
        </v-row>
      </v-form>
    </v-sheet>
    <Portal :to="`drawerAppend-${drawerId}`">
      <div class="pa-4">
        <v-btn
          x-large
          color="black"
          class="white--text"
          elevation="0"
          :loading="saving"
          block
          @click="edit_design_group ? saveName() : save()"
        >
          {{ edit_design_group && !edit_design_group.id ? 'Create':'Save' }}
        </v-btn>
      </div>
    </Portal>
  </Drawer>
</template>

<script>
import { DRAWERS } from '../../utils/constants';
import Drawer from '../../components/layout/Drawer';
import { mapGetters } from 'vuex';
import { mdiPencil, mdiAlertCircle, mdiKeyboardBackspace } from '@mdi/js';
import { cloneDeep } from 'lodash';

export default {
  name: 'ProjectDesignGroupDrawer',

  components: {
    Drawer
  },

  props: {
  },

  data () {
    return {
      valid: false,
      saving: false,
      drawerId: DRAWERS.PROJECT_DESIGN_GROUP,
      editIcon: mdiPencil,
      alertIcon: mdiAlertCircle,
      backIcon: mdiKeyboardBackspace,
      project: {},
      edit_design_group: null
    };
  },

  computed: {
    title () {
      if (this.edit_design_group) {
        return 'Group Name';
      }
      return 'Design Groups';
    },
    industry () {
      if (this.design_groups && this.design_groups.length) {
        return this.design_groups[0].industry || {};
      }
      return {};
    },
    ...mapGetters({
      initialData: 'drawers/data',
      drawerOpenedAt: 'drawers/lastOpenedAt',
      design_groups: 'admin/designgroups/list'
    })
  },

  watch: {
    drawerOpenedAt (val, oldVal) {
      if (this.drawerId === this.$store.getters['drawers/topDrawer']?.id) {
        const initial = this.initialData(this.drawerId) || {};
        this.project = cloneDeep(initial.project);
        console.log('draweropenedat');
      }
    }
  },

  methods: {
    save () {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch('projects/saveDesignGroup', this.project)
          .then(() => {
            this.$store.commit('drawers/CLOSE_ALL');
          })
          .catch((error) => {
            console.log(error);
            this.$root.$alert(
              'Error Occurred',
              'An error occurred while saving design group.'
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    saveName () {
      if (this.$refs.form.validate()) {
        this.saving = true;
        this.$store
          .dispatch('admin/designgroups/save', this.edit_design_group)
          .then(() => {
            this.edit_design_group = null;
          })
          .catch((error) => {
            console.log(error);
            this.$root.$alert(
              'Error Occurred',
              'An error occurred while saving a design group.'
            );
          })
          .finally(() => {
            this.saving = false;
          });
      }
    },
    editDesignGroup (item) {
      this.edit_design_group = cloneDeep(item || {});
    }
  }
};
</script>
